import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './FormSection.scss';

var FormSection = /*#__PURE__*/function (_Component) {
  _inherits(FormSection, _Component);

  var _super = _createSuper(FormSection);

  function FormSection() {
    _classCallCheck(this, FormSection);

    return _super.apply(this, arguments);
  }

  _createClass(FormSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          titleStyle = _this$props.titleStyle,
          style = _this$props.style,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: "row ".concat(styles.formSection),
        style: style
      }, /*#__PURE__*/React.createElement("h4", {
        className: styles.title,
        style: titleStyle
      }, title), children);
    }
  }]);

  return FormSection;
}(Component);

_defineProperty(FormSection, "propTypes", {
  children: PropTypes.node.isRequired,
  style: PropTypes.object,
  titleStyle: PropTypes.object
});

_defineProperty(FormSection, "defaultProps", {
  titleStyle: {},
  style: {}
});

export { FormSection as default };